<!--
    @首页-待办事项
-->
<template>
    <div class="dealt common-card">
        <div class="card-title">
            <p>待办事项
                <i class="el-icon-refresh" @click="reflash"></i>
            </p>
            <div class="title-navs">
                <span
                    v-for="item in navList"
                    :key="item.value"
                    @click="navHandler(item)"
                    :class="dataForm.taskType === item.value? 'active':null"
                >
                    {{item.text}}<i class="badge-defult" :class="item.num>0?'badge-red':null">{{item.num>=99?'99+':item.num}}</i>
                </span>
            </div>
            <!-- <el-input class="card-title--input" placeholder="请输入项目编号/名称">
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input> -->
        </div>
        <div class="dealt-content common-content">
            <div class="dealt-table scroll_hidden" @mouseover="mymouseIn" @mouseout="mymouseOut" ref="tablecontent">
                <el-table
                    :data="tableData"
                    size="mini"
                    style="width:100%;"
                    class="table-compatible"
                    v-loading="loading"
                    @sort-change="sortChange"
                    @filter-change="filterChange"
                    :height="setHeight"
                    ref="xtable"
                    stripe
                >
                    <el-table-column
                        label="序号"
                        type="index"
                        width="80px"
                        align="center"
                        :index="indexMethod"
                    ></el-table-column>
                    <el-table-column
                        v-for="item in columns"
                        :key="item.id"
                        :label="item.label"
                        :type="item.type"
                        :width="item.width"
                        :align="item.align"
                        :min-width="item.minWidth"
                        :show-overflow-tooltip="item.showOverflowTooltip"
                        :prop="item.prop"
                        :column-key="item.columnKey"
                        :sortable="item.sortable"
                        :filters="item.filters"
                    >
                        <!-- <template
                            v-if="item.renderHeader"
                            :slot="item.renderHeader?'header':null"
                            slot-scope="scope"
                        >
                            <el-popover
                                placement="bottom"
                                width="250"
                                trigger="click"
                            >
                                <span
                                    slot="reference"
                                    style="cursor: pointer;"
                                >
                                    {{ item.label }}
                                    <i class="el-icon-search"></i>
                                </span>
                                <div style="display: flex;">
                                    <el-input clearable></el-input>
                                    <el-button type="primary" size="mini" style="margin-left: 10px;">确定</el-button>
                                </div>
                            </el-popover>
                        </template> -->
                        <template slot-scope="scope">
                            <div v-if="item.btns" class="table-btns">
                                <el-button type="text" size="mini" @click="tableHandle(scope.row)">查看</el-button>
                            </div>
                            <span v-else>{{scope.row[item.prop]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="limitDom">
                <!-- <el-pagination
                    background
                    layout="total, sizes,prev, pager, next"
                    :page-sizes="[5, 10, 20]"
                    :page-size="pageSize"
                    :current-page="pageIndex"
                    :total="total"
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                ></el-pagination> -->
                <pagination
                    class="limit"
                    :layout="'total, sizes,prev, pager, next'"
                    :page-sizes="[5, 10, 20]"
                    :total="total"
                    :page.sync="pageIndex"
                    :limit.sync="pageSize"
                    @pagination="paginationChange">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {apiUserTaskList} from '@/server/new.js';
import mixin from '@/mixins/dealt.js';
import Pagination from '@/components/Pagination.vue';
export default {
    mixins: [mixin],
    components:{
        Pagination
    },
    data() {
        return {
            navList: [
                {text: '工程建设',value: 'GC',num: 0},
                {text: '政府采购',value: 'CG',num: 0},
                {text: '协同办公',value: 'XT',num: 0},
                {text: '其他',value: 'QT',num: 0},
                {text: '产权交易',value: 'CQ',num: 0},
            ],
            dataForm: {
                taskType: '', //类型
                datasetCodeList: [], //业务节点筛选数组
            },
            pageSize: 5,
            columns:[
                {id:40,label:'项目/标段名称',minWidth:'220px',showOverflowTooltip:true,prop:'projectName',renderHeader: true},
                {id:50,label:'项目/标段编号',minWidth:'180px',showOverflowTooltip:true,prop:'projectCode',renderHeader: true},
                {id:60,label:'业务节点',minWidth:'120px',align:'center',prop:'datasetCode',showOverflowTooltip:true,columnKey:'datasetCode',filters:[]},
                {id:70,label:'提交时间',minWidth:'140px',prop:'createDate',sortable: true},
                {id:90,label:'所属区域',minWidth:'160px',align:'center',prop:'tradeId',showOverflowTooltip:true},
                {id:110,label:'操作',width: '100px',align:'center',btns: true,fixed:'right'},
            ],
            flag: true,
            flagIndex: 0,
            isMounted: false,
        }
    },
    created() {
        this.dataForm.taskType = '';
        this.flagIndex = 0;
    },
    mounted() {
        this.navList.forEach((item) => {
            this.apiUserTaskTotal(item.value,-1);
        })
        this.isMounted = true;
    },
    computed: {
        setHeight:function() {
            if(this.isMounted) {
                return this.$refs.tablecontent.offsetHeight - 16;
            }
        }
    },
    methods:{
        fetchData() { //获取表格数据
            this.loading = true;
            apiUserTaskList({
                page: this.pageIndex,
                rows: this.pageSize,
                filter: {
                    taskType: this.dataForm.taskType,
                    datasetCodeList: this.dataForm.datasetCodeList
                }
            }).then(({data}) => {
                this.tableData = data.rows || [];
                this.total = data.total || 0;
            }).finally(() => {this.loading = false;})
        },
        tableHandle(row) {
            // window.location.href = row.url;
            this.$router.push({
                path: row.url
            })
        },
        reflash() { //刷新
            this.dataForm.datasetCodeList = [];
            this.$refs.xtable.clearFilter();
            this.fetchData();
        }
    }
}
</script>

<style lang="less" scoped>
.dealt {
    margin-top: 24px;
    // height: calc(50% - 48px);
    height: calc(50% - 90px);
    .title-navs {
        font-weight: normal;
        cursor: pointer;
        margin-left: 20px;
        span {
            padding: 10px 18px 10px 18px;
            position: relative;
            &:after {
                content: "";
                width: 0;
                height: 2px;
                background: @--color-primary;
                position: absolute;
                bottom: -4px;
                left: 0;
                transition: all .3s;
            }
            &:hover {
                color: @--color-primary;
            }
            &:hover:after {
                width: 100%;
            }
            &.active {
                color: @--color-primary;
                &:after {
                    width: 100%;
                }
            }
        }
    }
    .card-title--input {
        width: 15%;
        min-width: 220px;
        margin-left: auto;
    }
    .dealt-content {
        /deep/ .dealt-table {
            padding: 10px 10px 0 20px;
            height: calc(100% - 53px);
            overflow: auto;
            .table-compatible {
                color: rgba(0, 0, 0, 0.85);
            }
            .el-table--enable-row-hover .el-table__body tr:hover>td {
                background-color: #F0F7FF;
            }
            .table-btns {
                span + span {
                    margin-left: 10px;
                }
            }
        }
        /deep/ .limitDom {
            text-align: right;
            margin-right: 10px;
            .el-pagination {
                margin-top: 8px !important;
                font-weight: 400;
                .el-pager {
                    li {
                        margin: 0 4px !important;
                        background-color: #fff;
                        border: 1px solid #d8d8d8;
                        color: rgba(0,0,0,.85);
                        &:not(.disabled).active, &:not(.disabled):hover {
                            border-color: #2568ec;
                            color: #2568ec;
                        }
                    }
                }
            }
        }
    }
}
</style>
